import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, X, ZoomIn, ZoomOut } from "lucide-react";
import { imgUrl } from "@/lib/api";

export function Lightbox({ images, index, name, onClose, onIndex }) {
  const [zoom, setZoom] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");
  const touch = useRef(null);
  const n = images.length;
  const go = (d) => { setZoom(false); onIndex((index + d + n) % n); };

  useEffect(() => {
    const key = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight" && n > 1) go(1);
      if (e.key === "ArrowLeft" && n > 1) go(-1);
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", key);
    return () => { window.removeEventListener("keydown", key); document.body.style.overflow = prev; };
  });

  const toggleZoom = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setOrigin(`${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`);
    setZoom((z) => !z);
  };
  const onTouchStart = (e) => { touch.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touch.current == null || zoom || n < 2) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    touch.current = null;
  };
  const navBtn = "absolute top-1/2 -translate-y-1/2 z-10 h-12 w-12 grid place-items-center rounded-full bg-white/90 text-neutral-900 hover:bg-[var(--bk-yellow)] transition-colors";

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex flex-col" role="dialog" aria-modal="true" aria-label={`Foto ${name}`} data-testid="lightbox">
      <div className="flex items-center justify-between px-4 py-3 text-white">
        <div className="text-sm font-semibold truncate pr-4" data-testid="lightbox-counter">{name} · {index + 1}/{n}</div>
        <div className="flex gap-2">
          <button onClick={() => setZoom((z) => !z)} className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-white/20" aria-label={zoom ? "Perkecil" : "Perbesar"} data-testid="lightbox-zoom">{zoom ? <ZoomOut className="h-5 w-5" /> : <ZoomIn className="h-5 w-5" />}</button>
          <button onClick={onClose} className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-white/20" aria-label="Tutup" data-testid="lightbox-close"><X className="h-5 w-5" /></button>
        </div>
      </div>
      <div className="relative flex-1 min-h-0 overflow-hidden" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <img
          src={imgUrl(images[index])}
          alt={`${name} foto ${index + 1}`}
          onClick={toggleZoom}
          data-testid="lightbox-image"
          style={{ transformOrigin: origin }}
          className={`absolute inset-0 m-auto max-h-full max-w-full object-contain select-none transition-transform duration-300 ${zoom ? "scale-[2.2] cursor-zoom-out" : "cursor-zoom-in"}`}
        />
        {n > 1 && (
          <>
            <button onClick={() => go(-1)} className={`${navBtn} left-3`} aria-label="Foto sebelumnya" data-testid="lightbox-prev"><ChevronLeft className="h-6 w-6" /></button>
            <button onClick={() => go(1)} className={`${navBtn} right-3`} aria-label="Foto berikutnya" data-testid="lightbox-next"><ChevronRight className="h-6 w-6" /></button>
          </>
        )}
      </div>
      {n > 1 && (
        <div className="flex gap-2 justify-center overflow-x-auto no-scrollbar px-4 py-3">
          {images.map((u, k) => (
            <button key={k} onClick={() => { setZoom(false); onIndex(k); }} data-testid={`lightbox-thumb-${k}`} className={`h-14 w-14 shrink-0 rounded-md overflow-hidden border-2 ${k === index ? "border-[var(--bk-yellow)]" : "border-transparent opacity-60 hover:opacity-100"}`}>
              <img src={imgUrl(u)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
